const guidPattern = new RegExp('^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$', 'i');
const isValidGuid = (value) => {
    return guidPattern.test(value);
};
export const GuidModule = {
    isValidGuid
};
